import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    persistStore,
    PURGE,
    REGISTER,
    REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authSlice from './slices/auth';
import calendarSlice from './slices/calendar';
import notificationsSlice from './slices/notifications';

const rootReducer = combineReducers({
    auth: authSlice.reducer,
    calendar: calendarSlice.reducer,
    notifications: notificationsSlice.reducer,
});

const persistedReducer = persistReducer(
    {
        key: 'root',
        version: 2,
        storage: storage,
        // The unread count is live data; a persisted copy would flash a stale badge on reload.
        blacklist: ['notifications'],
    },
    rootReducer
);

const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>

export default store;
